import { useCallback, useState } from 'react';
import { SearchDocument } from 'types/Search';

export const REQUEST_BULK_LIMIT = 400;
export const COMPARE_BULK_LIMIT = 4;

export const useSelection = (compareModeActive: boolean) => {
  const [selectedItemList, setSelectedItemList] = useState<SearchDocument[]>(
    []
  );
  const [resetListState, setResetListState] = useState(false);
  const resetSelectedItemList = useCallback(() => {
    setSelectedItemList([]);
    setResetListState(prev => !prev);
  }, []);

  const removeItemFromSelectedItemList = useCallback(
    (id: string) =>
      setSelectedItemList(selectedItemList.filter(i => i.id !== id)),
    [selectedItemList]
  );
  const addItemToSelectedItemList = useCallback(
    (item: SearchDocument) => {
      setSelectedItemList([...selectedItemList, item]);
    },
    [selectedItemList]
  );

  const canSelectMore = compareModeActive
    ? selectedItemList.length < COMPARE_BULK_LIMIT
    : selectedItemList.length < REQUEST_BULK_LIMIT;

  return {
    selectedItemList,
    resetSelectedItemList,
    removeItemFromSelectedItemList,
    addItemToSelectedItemList,
    resetListState,
    canSelectMore,
    /**
     * @deprecated Don't use this anymore!
     */
    setSelectedItemList
  };
};
